import * as types from './types';
import { themeDDC } from '../../../utils/config';

const initialState = {
  show: false,
  countScreen: 0,
  fromPave: false,
  liteArr: themeDDC,
};

const processReducer = (state = initialState, action) => {
  const payload = action.payload;
  const type = action.type;
  switch (type) {
    case types.SHOW_PHOTOBAR: {
      return {
        ...state,
        show: true,
        countScreen: payload.countScreen,
      };
    }
    case types.HIDE_PHOTOBAR: {
      return {
        ...state,
        show: false,
        countScreen: payload.countScreen,
      };
    }
    case types.FROM_PAVE: {
      return {
        ...state,
        fromPave: true,
      };
    }
    case types.CONCAT_IMG_GALLERY: {
      return {
        ...state,
        liteArr: [...state.liteArr, payload.arr],
      };
    }
    case types.RESET_PHOTOBAR: {
      return initialState;
    }
    default:
      return state;
  }
};
export default processReducer;
